import { Redirect, useLocalSearchParams } from "expo-router";

/**
 * Old links to the standalone vendor checkout: the event's own details,
 * where its tickets open in the tickets sheet (RegisterExternal).
 */
export default function BuyRedirect() {
  const { accessId } = useLocalSearchParams<{ accessId: string }>();
  if (!accessId) return <Redirect href="/" />;
  return (
    <Redirect
      href={{ pathname: "/(app)/access/[accessId]", params: { accessId } }}
    />
  );
}
